import { BottomSheet } from "@/components/ui/bottom-sheet"
import { ANALYTICS_EVENTS } from "@/features/analytics"
import { advisorsList, AdvisorCarouselSection, type Advisor } from "@/features/advisors"

import type { RuneData } from "../../config/runes-data"

const RUNE_ADVISORS: Advisor[] = [
  advisorsList[0],
  advisorsList[12],
  advisorsList[13],
  advisorsList[8],
  advisorsList[1],
]

interface RuneInfoModalProps {
  rune: RuneData
  onClose: () => void
  onAsk: (advisor: Advisor) => void
}

/** Rune detail sheet with the meaning + advisor picks. Ported from RuneInfoModal. */
export function RuneInfoModal({ rune, onClose, onAsk }: RuneInfoModalProps) {
  return (
    <BottomSheet open onClose={onClose} title={rune.name}>
      <div className="flex flex-col items-center px-4 pb-2">
        <img src={rune.image} alt={rune.name} className="h-44 object-contain" />
        <div className="mt-2 flex flex-wrap items-center justify-center gap-1.5">
          <span className="rounded-2xl bg-purple-light/10 px-3 py-1 font-display text-base font-medium text-purple-light">
            {rune.aett} AETT
          </span>
          {rune.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-[23px] border border-purple-light/20 px-3 py-1.5 font-body text-sm text-purple-light/70"
            >
              {tag}
            </span>
          ))}
        </div>
        {/* biome-ignore lint/security/noDangerouslySetInnerHtml: rune copy is trusted static content */}
        <p
          className="mt-4 font-body text-base text-purple-light/70 [&_b]:font-medium [&_b]:text-purple-light"
          dangerouslySetInnerHTML={{ __html: rune.description }}
        />
      </div>

      <AdvisorCarouselSection
        title="Ask an advisor"
        subtitle="These guides can read what this rune means for your path"
        advisors={RUNE_ADVISORS}
        chatEvent={ANALYTICS_EVENTS.CHAT_WITH_RECOMMENDED_ADVISOR}
        onChatClick={onAsk}
      />
    </BottomSheet>
  )
}
